import RecentListPage from "./RecentListPage";

export default RecentListPage;
